import React from 'react';
import { GlobalAiRovoButtonWithBoundary } from '@jira/ai-rovo__button/src/GlobalAiRovoButtonWithBoundary.tsx';
import {
	GlobalBottomRightCornerContainer,
	BottomRightInlineItem,
} from '@jira/platform__controllers-layout/src/ui/bottom-right-corner/container/index.tsx';
import { PlaceholderWithNativeSuspense } from '@atlassian/jira-placeholder';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';

export function JiraSpaGlobalBottomRightCorner(): JSX.Element {
	return (
		<UFOSegment name="global-bottom-right-corner">
			<PlaceholderWithNativeSuspense name="global-right-bottom-corner-container" fallback={null}>
				<GlobalBottomRightCornerContainer>
					<BottomRightInlineItem>
						<GlobalAiRovoButtonWithBoundary />
					</BottomRightInlineItem>
				</GlobalBottomRightCornerContainer>
			</PlaceholderWithNativeSuspense>
		</UFOSegment>
	);
}
